<template>
    <!-- Componente para mostrar el menú responsive con sus respectivos links -->
    <div class="responsive-menu bg-white w-full max-w-screen-xl mx-auto pb-6 z-10 hidden leading-tight">
        <div>
            <a class="px-10 sm:px-16 h-12 flex justify-between items-center" :href="`${url}/${webpage}/modelos`">
                <p>Modelos</p>
                <div class="inline-block relative" style="top: -3px">
                    <i
                        class="border-solid border-black inline-block p-1 ml-5"
                        style="border-width: 0 2px 2px 0; transform: rotate(-45deg)"
                    ></i>
                </div>
            </a>
            <div class="px-4 sm:px-6">
                <div class="border-b border-light-gray border-solid"></div>
            </div>
        </div>
        <div>
            <div
                class="px-10 sm:px-16 h-12 flex justify-between items-center cursor-pointer"
                @click="showSubMenu('services')"
            >
                <p>Servicios</p>
                <div>
                    <div class="inline-block relative services-arrow down-arrow" style="top: -3px">
                        <i
                            class="border-solid border-black inline-block p-1 ml-5"
                            style="border-width: 0 2px 2px 0; transform: rotate(45deg)"
                        ></i>
                    </div>
                    <div class="inline-block relative services-arrow up-arrow hidden" style="top: -3px">
                        <i
                            class="border-solid border-black inline-block p-1 ml-5"
                            style="border-width: 0 2px 2px 0; transform: rotate(-135deg)"
                        ></i>
                    </div>
                </div>
            </div>
            <div class="services-submenu bg-light-brown hidden">
                <div
                    class="h-12 px-10 sm:px-16 w-full flex items-center"
                    :class="{ 'text-light-blue bg-white': routeSplit[1] === 'appointment' }"
                >
                    <a :href="`${url}/${webpage}/servicios/agenda-tu-cita`">Agendar cita</a>
                </div>
                <div
                    class="h-12 px-10 sm:px-16 w-full flex items-center"
                    :class="{ 'text-light-blue bg-white': routeSplit[1] === 'warranty' }"
                >
                    <a :href="`${url}/${webpage}/servicios/garantia`">Garantía</a>
                </div>
                <div
                    class="h-12 px-10 sm:px-16 w-full flex items-center"
                    :class="{ 'text-light-blue bg-white': routeSplit[1] === 'tire_protection' }"
                >
                    <a :href="`${url}/${webpage}/servicios/proteccion-de-llantas`">Protección de llantas</a>
                </div>
                <div
                    class="h-12 px-10 sm:px-16 w-full flex items-center"
                    :class="{ 'text-light-blue bg-white': routeSplit[1] === 'assistance' }"
                >
                    <a :href="`${url}/${webpage}/servicios/asistencia`">Asistencia</a>
                </div>
            </div>
            <div class="px-4 sm:px-6">
                <div class="border-b border-light-gray border-solid"></div>
            </div>
        </div>
        <div>
            <div
                class="px-10 sm:px-16 h-12 flex justify-between items-center cursor-pointer"
                @click="showSubMenu('financing')"
            >
                <p>Financiamiento</p>
                <div>
                    <div class="inline-block relative financing-arrow down-arrow" style="top: -3px">
                        <i
                            class="border-solid border-black inline-block p-1 ml-5"
                            style="border-width: 0 2px 2px 0; transform: rotate(45deg)"
                        ></i>
                    </div>
                    <div class="inline-block relative financing-arrow up-arrow hidden" style="top: -3px">
                        <i
                            class="border-solid border-black inline-block p-1 ml-5"
                            style="border-width: 0 2px 2px 0; transform: rotate(-135deg)"
                        ></i>
                    </div>
                </div>
            </div>
            <div class="financing-submenu bg-light-brown hidden">
                <div class="h-12 px-10 sm:px-16 w-full flex items-center">
                    <a :href="`${url}/${webpage}/modelos`">Solicitar cotización</a>
                </div>
                <div
                    class="h-12 px-10 sm:px-16 w-full flex items-center"
                    :class="{ 'text-light-blue bg-white': routeSplit[1] === 'hyundai_finance' }"
                >
                    <a :href="`${url}/${webpage}/financiamiento/hyundai-finance`">Hyundai Finance</a>
                </div>
                <div
                    class="h-12 px-10 sm:px-16 w-full flex items-center"
                    :class="{ 'text-light-blue bg-white': routeSplit[1] === 'hyundai_protect' }"
                >
                    <a :href="`${url}/${webpage}/financiamiento/hyundai-protect`">Hyundai Protect</a>
                </div>
            </div>
            <div class="px-4 sm:px-6">
                <div class="border-b border-light-gray border-solid"></div>
            </div>
        </div>
        <div v-if="hyundaiPromise">
            <div
                class="px-10 sm:px-16 h-12 flex justify-between items-center cursor-pointer"
                @click="showSubMenu('preowneds')"
            >
                <p>Seminuevos</p>
                <div>
                    <div class="inline-block relative preowneds-arrow down-arrow" style="top: -3px">
                        <i
                            class="border-solid border-black inline-block p-1 ml-5"
                            style="border-width: 0 2px 2px 0; transform: rotate(45deg)"
                        ></i>
                    </div>
                    <div class="inline-block relative preowneds-arrow up-arrow hidden" style="top: -3px">
                        <i
                            class="border-solid border-black inline-block p-1 ml-5"
                            style="border-width: 0 2px 2px 0; transform: rotate(-135deg)"
                        ></i>
                    </div>
                </div>
            </div>
            <div class="preowneds-submenu bg-light-brown hidden">
                <div
                    class="h-12 px-10 sm:px-16 w-full flex items-center"
                    :class="{ 'text-light-blue bg-white': routeSplit[1] === 'hyundai_promise' }"
                >
                    <a :href="`${url}/${webpage}/seminuevos`">Hyundai Promise Certificados</a>
                </div>
                <div v-if="preownedsLink" class="h-12 px-10 sm:px-16 w-full flex items-center">
                    <a :data-external="true" :href="preownedsLink" target="_blank">Otros seminuevos</a>
                </div>
            </div>
            <div class="px-4 sm:px-6">
                <div class="border-b border-light-gray border-solid"></div>
            </div>
        </div>
        <!-- <div v-if="webpage == 'premier' || webpage == 'tepepan' || webpage == 'farrera' || webpage == 'plasencia' || webpage == 'penta-sendero' || webpage == 'arcos-qro'">
            <a class="px-10 sm:px-16 h-12 flex justify-between items-center" :href="`${url}/${webpage}/hyundai-promise`">
                <p>Hyundai Promise</p>
                <div class="inline-block relative" style="top: -3px">
                    <i class="border-solid border-black inline-block p-1 ml-5" style="border-width: 0 2px 2px 0; transform: rotate(-45deg);"></i>
                </div>
            </a>
            <div class="px-4 sm:px-6">
                <div class="border-b border-light-gray border-solid"></div>
            </div>
        </div> -->
        <div v-else-if="preownedsLink">
            <a
                :data-external="true"
                class="px-10 sm:px-16 h-12 flex justify-between items-center"
                :href="preownedsLink"
                target="_blank"
            >
                <p>Seminuevos</p>
                <div class="inline-block relative" style="top: -3px">
                    <i
                        class="border-solid border-black inline-block p-1 ml-5"
                        style="border-width: 0 2px 2px 0; transform: rotate(-45deg)"
                    ></i>
                </div>
            </a>
            <div class="px-4 sm:px-6">
                <div class="border-b border-light-gray border-solid"></div>
            </div>
        </div>
        <div>
            <a
                class="px-10 sm:px-16 h-12 flex justify-between items-center"
                :href="`${url}/${webpage}/servicios/agenda-tu-cita`"
            >
                <div class="flex">
                    <img class="w-6 h-full mr-4" :src="`${url}/images/icons/date_icon.png`" alt="Agenda tu cita" />
                    <p>Agenda tu cita</p>
                </div>
                <div class="inline-block relative" style="top: -3px">
                    <i
                        class="border-solid border-black inline-block p-1 ml-5"
                        style="border-width: 0 2px 2px 0; transform: rotate(-45deg)"
                    ></i>
                </div>
            </a>
            <div class="px-4 sm:px-6">
                <div class="border-b border-light-gray border-solid"></div>
            </div>
        </div>
        <div>
            <a
                :data-external="whatsAppLink ? 'true' : 'false'"
                class="px-10 sm:px-16 h-12 flex justify-between items-center"
                :href="whatsAppLink ? whatsAppLink : `${url}/${webpage}/contacto`"
                :target="whatsAppLink ? '_blank' : '_self'"
            >
                <div class="flex">
                    <img class="w-6 h-full mr-4" :src="`${url}/images/icons/contact_menu_icon.png`" alt="Contáctanos" />
                    <p>Contáctanos</p>
                </div>
                <div class="inline-block relative" style="top: -3px">
                    <i
                        class="border-solid border-black inline-block p-1 ml-5"
                        style="border-width: 0 2px 2px 0; transform: rotate(-45deg)"
                    ></i>
                </div>
            </a>
            <div class="px-4 sm:px-6">
                <div class="border-b border-light-gray border-solid"></div>
            </div>
        </div>
        <div>
            <a class="px-10 sm:px-16 h-12 flex justify-between items-center" :href="`${url}/${webpage}/modelos`">
                <div class="flex">
                    <img class="w-6 h-full mr-4" :src="`${url}/images/icons/quote_icon.png`" alt="Cotizador" />
                    <p>Cotizador</p>
                </div>
                <div class="inline-block relative" style="top: -3px">
                    <i
                        class="border-solid border-black inline-block p-1 ml-5"
                        style="border-width: 0 2px 2px 0; transform: rotate(-45deg)"
                    ></i>
                </div>
            </a>
            <div class="px-4 sm:px-6">
                <div class="border-b border-light-gray border-solid"></div>
            </div>
        </div>
        <div>
            <a
                class="px-10 sm:px-16 h-12 flex justify-between items-center"
                :href="`${url}/${webpage}/modelos/prueba-de-manejo`"
            >
                <div class="flex">
                    <img
                        class="w-6 h-full mr-4"
                        :src="`${url}/images/icons/test_drive_icon.png`"
                        alt="Solicitar prueba de manejo"
                    />
                    <p>Solicitar prueba de manejo</p>
                </div>
                <div class="inline-block relative" style="top: -3px">
                    <i
                        class="border-solid border-black inline-block p-1 ml-5"
                        style="border-width: 0 2px 2px 0; transform: rotate(-45deg)"
                    ></i>
                </div>
            </a>
            <div class="px-4 sm:px-6">
                <div class="border-b border-light-gray border-solid"></div>
            </div>
        </div>
        <div>
            <a
                class="px-10 sm:px-16 h-12 flex justify-between items-center"
                :href="`${url}/${webpage}/quejas-y-sugerencias`"
            >
                <div class="flex items-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-7 h-full mr-4"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
                        />
                    </svg>

                    <p>Quejas y sugerencias</p>
                </div>
                <div class="inline-block relative" style="top: -3px">
                    <i
                        class="border-solid border-black inline-block p-1 ml-5"
                        style="border-width: 0 2px 2px 0; transform: rotate(-45deg)"
                    ></i>
                </div>
            </a>
            <div class="px-4 sm:px-6">
                <div class="border-b border-light-gray border-solid"></div>
            </div>
        </div>

        <!-- <div>
            <div class="px-10 sm:px-16 h-12 flex justify-between items-center">
                <div class="flex">
                    <img class="w-5 h-full mr-5" :src="`${url}/images/icons/chat_icon.png`" alt="Hyundai Chat">
                    <p>Hyundai Chat</p>
                </div>
                <div class="inline-block relative" style="top: -3px">
                    <i class="border-solid border-black inline-block p-1 ml-5" style="border-width: 0 2px 2px 0; transform: rotate(-45deg);"></i>
                </div>
            </div>
            <div class="px-4 sm:px-6">
                <div class="border-b border-light-gray border-solid"></div>
            </div>
        </div> -->
        <!-- <div>
            <div class="px-10 sm:px-16 h-12 flex justify-between items-center">
                <div class="flex">
                    <img class="w-8 h-full mr-3 -ml-1" :src="`${url}/images/icons/live_icon.png`" alt="Hyundai Live">
                    <p>Hyundai Live</p>
                </div>
                <div class="inline-block relative" style="top: -3px">
                    <i class="border-solid border-black inline-block p-1 ml-5" style="border-width: 0 2px 2px 0; transform: rotate(-45deg);"></i>
                </div>
            </div>
            <div class="px-4 sm:px-6">
                <div class="border-b border-light-gray border-solid"></div>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    props: ["route-name", "menuData", "hyundaiPromise"],
    data() {
        return {
            url: $(".url").text(),
            webpage: $(".webpage").text(),
            // whatsAppLink: '',
            // preownedsLink: '',
            // showMenu: false,
        };
    },
    methods: {
        // Función para desplegar el sub menú del elemeto
        // del menú correspondiente
        showSubMenu(submenu) {
            if ($(`.${submenu}-submenu`).css("display") === "none") {
                $(`.${submenu}-submenu`).slideDown();
                $(`.${submenu}-arrow.down-arrow`).hide();
                $(`.${submenu}-arrow.up-arrow`).show();
            } else {
                $(`.${submenu}-submenu`).slideUp();
                $(`.${submenu}-arrow.up-arrow`).hide();
                $(`.${submenu}-arrow.down-arrow`).show();
            }
        },
        // getMenuLinks() {
        //     axios.get(`${this.url}/${this.webpage}/get-menu-links`)
        //     .then(resp => {
        //         if (resp.data) {
        //             if (resp.data.whatsAppLink) this.whatsAppLink = `https://wa.me/521${resp.data.whatsAppLink}`
        //             if (resp.data.preownedsLink) this.preownedsLink = resp.data.preownedsLink.search('http') > -1 ? resp.data.preownedsLink : `https://${resp.data.preownedsLink}`
        //         }
        //     })
        //     .catch(err => {
        //         console.log(err);
        //     })
        // }
    },
    computed: {
        // Retorna el nombre de la ruta separada por puntos
        // para determinar la ruta en la que se encuentra actualmente
        // el usuario
        routeSplit() {
            return this.routeName.split(".");
        },
        // Retorna el objeto con los links del menú
        menuLinks() {
            return JSON.parse(this.menuData);
        },
        // Retorna el link de whatsapp formateado
        whatsAppLink() {
            return this.menuLinks.whatsAppLink ? `https://wa.me/521${this.menuLinks.whatsAppLink}` : "";
        },
        // Retorna el link de seminuevos formateado si está disponible
        preownedsLink() {
            if (this.menuLinks.preownedsLink) {
                return this.menuLinks.preownedsLink.search("http") > -1
                    ? this.menuLinks.preownedsLink
                    : `https://${this.menuLinks.preownedsLink}`;
            }
            return "";
        },
    },
    mounted() {
        // $('.responsive-menu').css('height', '100%')
        // this.getMenuLinks()
        // Despliega el submenu correspondiente en cuanto
        // se monta el componente
        this.showSubMenu(this.routeSplit[0]);
    },
    created() {
        // Escucha el evento del componente del icono del menú para
        // determinar si mostrar o no el menú
        this.$eventBus.$on("on-click-menu-icon", (showMenu) => {
            // this.showMenu = showMenu
            if (showMenu) {
                $(".responsive-menu").slideDown();
                // $('.content').fadeTo('fast', 0.3)
            } else {
                $(".responsive-menu").slideUp();
                // $('.content').fadeTo('fast', 1)
            }
        });
    },
    beforeDestroy() {
        this.$eventBus.$off("on-click-menu-icon");
    },
};
</script>

<style></style>
